import {commonStyles} from '../annotation/commonStyles'
import {toStyleProperties} from '../annotation/toStyleProperties'

export const embeddedFormStyleProperties = toStyleProperties(commonStyles)
